import {
	type Query,
	QueryCache,
	QueryClient,
	type QueryKey,
} from "@tanstack/react-query";
import { useEffect } from "react";

type ErrorListener = (
	error: Error,
	query: Query<unknown, unknown, unknown, QueryKey>,
) => void;

const onErrorListeners: ErrorListener[] = [];

/**
 * @param callback Called for every query error, e.g. to show it to the user.
 */
export function useQueryError(callback: ErrorListener) {
	useEffect(() => {
		onErrorListeners.push(callback);

		return () => {
			const index = onErrorListeners.indexOf(callback);
			if (index >= 0) {
				onErrorListeners.splice(index, 1);
			}
		};
	});
}

export const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			for (const listener of onErrorListeners) {
				listener(error, query);
			}
		},
	}),
	defaultOptions: {
		queries: {
			retry: 1,
		},
	},
});
